import {HStack, StackProps} from '@chakra-ui/react'
import {FormEvent} from 'react'

function onSubmit(event: FormEvent<HTMLFormElement>) {
  event.preventDefault()
}

export function ResourcesFiltersContainer({children, ...props}: StackProps) {
  return (
    <HStack width="100%" justifyContent="space-between" {...props} asChild>
      <form onSubmit={onSubmit}>{children}</form>
    </HStack>
  )
}
